
import { TbMail, TbPhone } from 'react-icons/tb';
import { Col, Flex, Icon, Row, Typography } from '../../../ppui';
import { OrganasationLogo, OrganasationName, OrganizationHeader, OrganizationWrapper } from '../../style';
import Logo from '../../../assets/svgs/logo';
import OrganasationCover from '../../../assets/svgs/organasation-svg';
import { LuGlobe } from 'react-icons/lu';


const OrganizationStickyHeader = ({orgDetails}) => {
  return (
 <>
        <OrganizationWrapper>
        <OrganizationHeader>
          <OrganasationLogo>
              {orgDetails?.logo ? 
            
              <img src={`${orgDetails?.path + orgDetails?.logo}`} />
                :
                <Logo/>
            }

          </OrganasationLogo>
          <OrganasationName>
            <OrganasationCover/>
            <Typography variant='h3' color="light" textCase="capitalize" mb="0" colorVariant="light">
              {orgDetails?.org_name || 'N/A'}
            </Typography>
            <Row alignItem="flex-end" >
              <Col>
                <Flex alignItem="center" gap={5}>
                  <Icon color={"light"}>
                    <TbPhone />
                  </Icon>
                  <Typography variant="body2" mb={"0"}  color="light" colorVariant="dark">
                    {orgDetails?.phone || 'N/A'}
                  </Typography>
                  {orgDetails?.landline && 
                  <Typography variant="body2" mb={"0"}  color="light" colorVariant="dark">
                    / {orgDetails?.landline}
                  </Typography>
                  }
                </Flex>
                <Flex alignItem="center" gap={5}>
                  <Icon color={"light"}>
                    <TbMail />
                  </Icon>
                  <Typography variant="body2" mb={"0"}  color="light" colorVariant="dark">
                    {orgDetails?.email || 'N/A'}
                  </Typography>
                </Flex>
                {orgDetails?.domain_name &&
                  <Flex alignItem="center" gap={5}>
                    <Icon color={"light"}>
                      <LuGlobe/>
                    </Icon>
                    <Typography variant="body2" mb={"0"}  color="light" colorVariant="dark">
                      {orgDetails?.domain_name || 'N/A'}
                    </Typography>
                  </Flex>
                }
              </Col>
            </Row>
          </OrganasationName>
        </OrganizationHeader>
      </OrganizationWrapper>
         </>
  )
}

export default OrganizationStickyHeader